import { fetchAllConcepts, ResolvedConcept } from '@/libs/contentful/rest';
import { BlogNavigationProps } from './types';
import BlogNav from './BlogNav';
import { readRedisCache, writeRedisCache } from '@/utils/redis/redisCache';
import { RedisKey } from '@/utils/redis/redisConfig';

const BlogNavigation = async ({ ...props }: BlogNavigationProps) => {
  const ITG_CONCEPTS = 'itgConceptsCacheKey';

  let allConcepts = await readRedisCache<ResolvedConcept[]>(ITG_CONCEPTS, RedisKey.ItgConcepts);
  if (!allConcepts) {
    allConcepts = await fetchAllConcepts({ order: ['prefLabel'] });
    await writeRedisCache(ITG_CONCEPTS, allConcepts, RedisKey.ItgConcepts);
  }

  return <BlogNav {...props} taxonomies={allConcepts} />;
};

export default BlogNavigation;
